const formatPriority = ["medium", "large", "small", "thumbnail"];

type StrapiMediaLike = {
  data?: {
    attributes?: {
      formats?: Record<string, { url?: string }>;
      url?: string;
    };
  };
  attributes?: {
    formats?: Record<string, { url?: string }>;
    url?: string;
  };
  formats?: Record<string, { url?: string }>;
  url?: string;
};

function getFormats(media?: StrapiMediaLike | null) {
  return media?.data?.attributes?.formats ?? media?.attributes?.formats ?? media?.formats;
}

function getDirectUrl(media?: StrapiMediaLike | null) {
  return media?.data?.attributes?.url ?? media?.attributes?.url ?? media?.url ?? "";
}

export function getMediaPath(media?: StrapiMediaLike | null, preferredFormats: string[] = formatPriority) {
  const formats = getFormats(media);

  for (const formatName of preferredFormats) {
    const formatUrl = formats?.[formatName]?.url;
    if (formatUrl) {
      return formatUrl;
    }
  }

  return getDirectUrl(media);
}

export function getMediaUrl(
  media?: StrapiMediaLike | null,
  baseUrl: string = process.env.REACT_APP_ETNOSOUL_BASE_URL ?? "",
  preferredFormats: string[] = formatPriority
) {
  const path = getMediaPath(media, preferredFormats);

  if (!path) {
    return "";
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${baseUrl}${path}`;
}
